module.exports = __webpack_public_path__ + "images/frontpage_desktop@3x.jpg?333733d2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_desktop@3x.jpg
// module id = 635
// module chunks = 7